import { useQuery } from '@tanstack/react-query'
import { Play, Pause, LogOut } from 'lucide-react'
import { apiClient } from '@/lib/api.ts'
import { Badge, LoadingState } from '@/components/ui'

interface TimeStatus {
  isClockedIn: boolean
  clockInTime?: string
  totalMinutesToday: number
  isOnBreak: boolean
  breakStartTime?: string
}

export default function TimeStatusWidget() {
  const { data: status, isLoading } = useQuery({
    queryKey: ['time-status'],
    queryFn: async () => {
      const { data } = await apiClient.get<TimeStatus>('/time/status')
      return data
    },
    refetchInterval: 60 * 1000,
  })

  if (isLoading || !status) {
    return <LoadingState size="sm" label="" />
  }

  const hours = Math.floor(status.totalMinutesToday / 60)
  const minutes = status.totalMinutesToday % 60

  const statusVariant = status.isOnBreak
    ? 'warning'
    : status.isClockedIn
      ? 'success'
      : 'neutral'

  const statusText = status.isOnBreak
    ? 'Pause'
    : status.isClockedIn
      ? 'Anwesend'
      : 'Abwesend'

  const StatusIcon = status.isOnBreak ? Pause : status.isClockedIn ? Play : LogOut

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3">
        <Badge variant={statusVariant} size="md">
          <StatusIcon className="h-3.5 w-3.5" />
          {statusText}
        </Badge>
        <div className="text-h3 text-gray-800">
          {hours}h {String(minutes).padStart(2, '0')}m
        </div>
      </div>

      {status.isClockedIn && status.clockInTime && (
        <div className="text-caption text-gray-500">
          Eingestempelt seit {new Date(status.clockInTime).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })} Uhr
        </div>
      )}

      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className={`h-2 rounded-full transition-all ${
            status.totalMinutesToday >= 480 ? 'bg-green-500' : 'bg-brand-500'
          }`}
          style={{ width: `${Math.min(100, (status.totalMinutesToday / 480) * 100)}%` }}
        />
      </div>
      <div className="flex justify-between text-caption text-gray-400">
        <span>0h</span>
        <span>Soll: 8h</span>
      </div>
    </div>
  )
}
